import { render, staticRenderFns } from "./AccountsTable.vue?vue&type=template&id=3397a4c8&scoped=true&"
import script from "./AccountsTable.vue?vue&type=script&lang=js&"
export * from "./AccountsTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountsTable.vue?vue&type=style&index=0&id=3397a4c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3397a4c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
